import { Component, inject, signal } from '@angular/core';
import { AuthenticationService } from '@app/security/authentication.service';
import { Roles } from '@scenario/enums/roles.enum';
import { AsyncPipe } from '@angular/common';
import {
  SegmentedControlComponent,
  SegmentedControlOptionComponent,
  TileComponent,
} from '@totalenergiescode/tds-angular';
import { ManagePmoComponent } from '../manage-pmo/manage-pmo.component';
import { ManageAnalystComponent } from '../manage-analyst/manage-analyst.component';
import { ManageRegionManagerComponent } from '../manage-region-manager/manage-region-manager.component';

@Component({
    selector: 'app-admin-page',
    templateUrl: './admin-page.component.html',
  imports: [AsyncPipe, ManageAnalystComponent, ManagePmoComponent, SegmentedControlComponent, SegmentedControlOptionComponent, TileComponent, ManageRegionManagerComponent]
})
export class AdminPageComponent {
  private readonly authenticationService = inject(AuthenticationService);
  public connectedUser = this.authenticationService.connectedUser;
  public Roles = Roles;
  public selectedTab = signal(1);
}
